import React, { Component } from 'react';
import { ApolloConsumer } from '@apollo/client';

import { KeepAliveQuery } from './queries';

type KeepAliveProps = {
  onTimeout: () => void;
};

class KeepAlive extends Component<KeepAliveProps> {
  componentDidMount() {
    const { onTimeout } = this.props;
    this.intervalId = setInterval(() => {
      onTimeout();
    }, 60000);
  }

  componentWillUnmount() {
    const { intervalId } = this;

    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  intervalId: any = null;

  render() {
    return null;
  }
}

const KeepAliveContainer = () => (
  <ApolloConsumer>
    {(client: any) => <KeepAlive onTimeout={() => client.query({ query: KeepAliveQuery })} />}
  </ApolloConsumer>
);

export default KeepAliveContainer;
